import { render } from "./TabListByDate.vue?vue&type=template&id=2d595aea&scoped=true"
import script from "./TabListByDate.vue?vue&type=script&lang=js"
export * from "./TabListByDate.vue?vue&type=script&lang=js"

import "@/assets/scss/results/listByDate.scss?vue&type=style&index=0&id=2d595aea&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d595aea"]])

export default __exports__